module.exports = __webpack_public_path__ + "static/media/controller-blue.ebe13f2e.svg";